import { getDefaultLang } from "@cervval.js/common/src/i18n/languages";

const _fr = {
    productOverride: {
        price: "Tarif",
        duration: "Durée",
        description: "Note"
    },
    visio: {
        modality: "Modalité"
    },
    product: {
        name: "Nom",
        price: "Tarif",
        duration: "Durée",
        description: "Description",
        durationWeakUnitPlural: "minutes"
    },
    timeslot: {
        start: "Début",
        finish: "Fin"
    }
};

export type _I18nPropertyConfig = typeof _fr;

const _en: _I18nPropertyConfig = {
    productOverride: {
        price: "Price",
        duration: "Duration",
        description: "Note"
    },
    visio: {
        modality: "Modality"
    },
    product: {
        name: "Name",
        price: "Price",
        duration: "Duration",
        description: "Description",
        durationWeakUnitPlural: "minutes"
    },

    timeslot: {
        start: "Start",
        finish: "Finish"
    }
};

/**
 * Return value in required language
 * @param lang Chosen lang
 * @returns 
 */
export function I18nPropertyConfig(lang?: string): _I18nPropertyConfig {
    lang = lang ?? getDefaultLang();
    switch (lang) {
        case "en":
            return _en;
        case "fr":
        default:
            return _fr;
    }
}